import React, {Component} from 'react';
import Scene from './Scene';
import {Button, Container, Header, List, Message} from 'semantic-ui-react';

import 'semantic-ui-css/semantic.min.css';
import './App.css';

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
            pointerLock: 'pointerLockElement' in document || 'mozPointerLockElement' in document || 'webkitPointerLockElement' in document
                ? false
                : null,
            webgl: false
        };
        this.pointerLockChange = () => {
            this.setState({
                pointerLock: document.pointerLockElement === this.refs.app || document.mozPointerLockElement === this.refs.app || document.webkitPointerLockElement === this.refs.app
            });
        };
        this.requestPointerLock = () => {
            if (this.state.pointerLock === false) {
                this.refs.app.requestPointerLock = this.refs.app.requestPointerLock || this.refs.app.mozRequestPointerLock || this.refs.app.webkitRequestPointerLock;
                this
                    .refs
                    .app
                    .requestPointerLock();
            }
        };
        this.exitPointerLock = () => {
            if (this.state.pointerLock === true) {
                document.exitPointerLock = document.exitPointerLock || document.mozExitPointerLock || document.webkitExitPointerLock;
                document.exitPointerLock();
            }
        };
        this.onKeyDown = (event) => {
            switch (event.keyCode) {
                case 27: // escape
                    this.exitPointerLock();
                    break;
                default:
                    break;
            }
        };
    }

    componentDidMount() {
        if (this.state.pointerLock !== null) {
            document.addEventListener('keydown', this.onKeyDown, false);
            document.addEventListener('pointerlockchange', this.pointerLockChange, false);
            document.addEventListener('mozpointerlockchange', this.pointerLockChange, false);
            document.addEventListener('webkitpointerlockchange', this.pointerLockChange, false);
            document.addEventListener('pointerlockerror', console.log, false);
            document.addEventListener('mozpointerlockerror', console.log, false);
            document.addEventListener('webkitpointerlockerror', console.log, false);
        }
        if (window.WebGLRenderingContext) {
            const canvas = document.createElement('canvas'),
                webgl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
            this.setState({webgl: Boolean(webgl)});
        }
    }

    componentWillUnmount() {
        if (this.state.pointerLock !== null) {
            document.removeEventListener('keydown', this.onKeyDown, false);
            document.removeEventListener('pointerlockchange', this.pointerLockChange, false);
            document.removeEventListener('mozpointerlockchange', this.pointerLockChange, false);
            document.removeEventListener('webkitpointerlockchange', this.pointerLockChange, false);
            document.removeEventListener('pointerlockerror', console.log, false);
            document.removeEventListener('mozpointerlockerror', console.log, false);
            document.removeEventListener('webkitpointerlockerror', console.log, false);
        }
        this.exitPointerLock();
    }

    render() {
        const alerts = [],
            instructions = this.state.webgl
                ? <div className="App-instructions">
                        <Button size='massive' onClick={this.requestPointerLock}>Play</Button>
                        <List>
                            <List.Item>
                                <List.Header>W, A, S, D</List.Header>
                                Move
                            </List.Item>
                            <List.Item>
                                <List.Header>SPACE</List.Header>
                                Jump
                            </List.Item>
                            <List.Item>
                                <List.Header>MOUSE</List.Header>
                                Look around
                            </List.Item>
                        </List>
                    </div>
                : null,
            content = this.state.webgl && this.state.pointerLock
                ? <Scene/>
                : <Container text={true} className="App-interface">
                    <Header size='huge'>Battle Royale</Header>
                    {alerts.map(message => <Message negative="negative">{message}</Message>)}
                    {instructions}
                </Container>;
        if (this.state.pointerLock === null) {
            alerts.push('Your browser may not support Pointer Lock API.');
        }
        if (this.state.webgl === false) {
            alerts.push('Your browser or device may not support WebGL.');
        }
        return <div ref="app" className="App">{content}</div>;
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js